/**
 * 카드 등록 폼 필드 검증.
 *
 * NICEPAY 직접 입력 흐름 — POST /payments/methods body.detail의 형식 검증.
 * 백엔드가 서버 측 재검증을 하므로 클라 검증은 UX 빠른 피드백용.
 */

export type IdentificationType = 'PERSONAL' | 'BUSINESS'

export interface CardFormValues {
  identificationType: IdentificationType
  cardNo: string
  expMonth: string
  expYear: string
  idNo: string
  cardPw: string
}

const DIGITS_16 = /^\d{16}$/
const DIGITS_2 = /^\d{2}$/
const DIGITS_6 = /^\d{6}$/
const DIGITS_10 = /^\d{10}$/

const MIN_MONTH = 1
const MAX_MONTH = 12

/** 카드번호 16자리 숫자 */
export function validateCardNo(value: string): boolean {
  return DIGITS_16.test(value)
}

/** 유효기간 월 — 2자리 + 01~12 */
export function validateExpMonth(value: string): boolean {
  if (!DIGITS_2.test(value)) return false
  const month = Number(value)
  return month >= MIN_MONTH && month <= MAX_MONTH
}

/** 유효기간 연도 — 2자리 숫자 (YY) */
export function validateExpYear(value: string): boolean {
  return DIGITS_2.test(value)
}

/** 카드 비밀번호 앞 2자리 — 2자리 숫자 */
export function validateCardPw(value: string): boolean {
  return DIGITS_2.test(value)
}

/** 개인=생년월일 6자리(YYMMDD), 법인=사업자등록번호 10자리 */
export function validateIdNo(value: string, identificationType: IdentificationType): boolean {
  return identificationType === 'PERSONAL' ? DIGITS_6.test(value) : DIGITS_10.test(value)
}

/** 모든 필드가 검증을 통과하면 true */
export function isValidCardForm(values: CardFormValues): boolean {
  return (
    validateCardNo(values.cardNo) &&
    validateExpMonth(values.expMonth) &&
    validateExpYear(values.expYear) &&
    validateCardPw(values.cardPw) &&
    validateIdNo(values.idNo, values.identificationType)
  )
}
